const t = {
  name: "UpliftAuthenticate",
  dimensions: { width: 24, height: 24 },
  content: `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M17 2h5v5h2V0h-7zM15.888 10.587l-4.948 4.947-2.827-2.827 1.414-1.414 1.413 1.413 3.533-3.533z" style="fill: currentColor;"/><path fill="#fff" d="M13 4V2h-1.5C5.698 2 1 6.698 1 12.5S5.698 23 11.5 23 22 18.302 22 12.5V11h-2V4zm0 2h5v5h2v1.5c0 4.698-3.802 8.5-8.5 8.5A8.496 8.496 0 0 1 3 12.5C3 7.802 6.802 4 11.5 4H13z" style="fill: currentColor;"/></svg>
  `
};
export {
  t as UpliftAuthenticate
};
